import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
export function Funding() {
  return <section id="foerderungen" className="py-24 md:py-32 bg-sage-light" data-id="element-207">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-209">
          <div className="text-center mb-12" data-id="element-210">
            <h2 className="text-4xl md:text-5xl font-serif text-accent mb-6" data-id="element-211">
              Förderungen sinnvoll nutzen
            </h2>
            <p className="text-lg text-accent/70 font-light" data-id="element-212">
              Die energetische Sanierung von Bestandsgebäuden wird staatlich
              stark gefördert. Als zertifizierte Ingenieurin und
              Energieeffizienz-Expertin unterstütze ich Sie dabei, den Überblick
              zu behalten und die optimalen Zuschüsse für Ihr Projekt zu
              sichern.
            </p>
          </div>

          <div className="space-y-6 text-accent/80 font-light text-lg leading-relaxed mb-10" data-id="element-213">
            <ul className="grid md:grid-cols-2 gap-6 mt-8" data-id="element-214">
              <li className="bg-white p-8 rounded-2xl shadow-sm border border-accent/5" data-id="element-215">
                <h4 className="font-medium text-accent mb-3" data-id="element-216">
                  Individueller Sanierungsfahrplan (iSFP)
                </h4>
                <p className="text-base" data-id="element-217">
                  Die Erstellung eines iSFP wird vom BAFA mit bis zu 80%
                  bezuschusst. Zudem erhalten Sie einen zusätzlichen Förderbonus
                  von 5% auf die Umsetzung der darin empfohlenen Maßnahmen.
                </p>
              </li>
              <li className="bg-white p-8 rounded-2xl shadow-sm border border-accent/5" data-id="element-218">
                <h4 className="font-medium text-accent mb-3" data-id="element-219">
                  BAFA & KfW Förderungen
                </h4>
                <p className="text-base" data-id="element-220">
                  Egal ob Einzelmaßnahmen (wie Fenstertausch oder
                  Heizungsoptimierung) über das BAFA oder Komplettsanierungen
                  zum Effizienzhaus über die KfW – ich übernehme die technische
                  Prüfung und Bestätigung für Ihre Anträge.
                </p>
              </li>
            </ul>
          </div>

          <div className="flex items-start gap-3 p-4 bg-accent/5 rounded-lg text-sm text-accent/60 max-w-2xl mx-auto" data-id="element-221">
            <InfoIcon size={20} className="shrink-0 mt-0.5 text-accent/40" data-id="element-222" />
            <p data-id="element-223">
              Förderprogramme können sich ändern. Die individuelle
              Förderfähigkeit wird projektbezogen geprüft.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}